import { useFormikContext } from "formik"
import { ImportIdCardsFormValues, UpdateKeyListIdCards, UserGroup } from "../idCardsTypes"
import {
    FormikImportCsvFile,
    ImportCsvFileField,
} from "../../../../../../shared/components/importCsv/FormikImportCsvFile"

export const ImportFile = () => {
    const { values } = useFormikContext<ImportIdCardsFormValues>()

    const fieldsConfig: ImportCsvFileField[] = [
        { name: "cardId", label: "Card ID", optional: false },
        {
            name: "employeeNo",
            label: "Employee number",
            optional: values.updateKey !== UpdateKeyListIdCards.EMPLOYEE_NUMBER,
        },
        { name: "initials", label: "Initials", optional: values.updateKey !== UpdateKeyListIdCards.INITIALS },
        { name: "email", label: "Email", optional: values.updateKey !== UpdateKeyListIdCards.EMAIL },
        { name: "userGroupName", label: "User group", optional: values.userGroupId !== UserGroup.ALL },
    ]

    return <FormikImportCsvFile<ImportIdCardsFormValues> fields={fieldsConfig} />
}
